import React, {  Component } from 'react';

export default class EstRetailPriceTooltipOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }
    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
        this.props.handleDialog && this.props.handleDialog('EstRetailPriceTooltipOverlayDialog', false);
    }
    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }
    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="estRetailPriceTooltip">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow">
                    <a className="closeButton" onClick={this.closeDialog.bind(this)}>×</a>
                    <h2 className="title">Manufacturer&apos;s Suggested Retail Price (MSRP)</h2>
                    <div>
                        <p>Actual retail prices may vary by dealer. MSRP applies to the continental 48 United States and does not include such items as delivery, installation, installation accessories (i.e. range cords), or removal of old appliances. Consult your local authorized GE dealer for its prices.</p>
                    </div>
                 </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/components/dialogs/estRetailPriceTooltipOverlayDialog.js